import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "col-md-6 col-12 mb-3 px-md-3 px-2 font5-responsive",
    style: { "align-items": "center" }
};
const _hoisted_2 = { class: "col-md-3 col-6 mb-3 px-2" };
const _hoisted_3 = { class: "col-md-3 col-6 mb-3 pl-2 pr-2" };
const _hoisted_4 = {
    class: "col-md-6 col-12 mb-3 px-md-3 px-2 font5-responsive",
    style: { "align-items": "center" }
};
const _hoisted_5 = { class: "col-md-3 col-6 mb-3 px-2" };
const _hoisted_6 = { class: "col-md-3 col-6 mb-3 pl-2 pr-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["row mt-sm-3 mt-1 mb-3", { 'd-none': _ctx.current_step === 1 }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-1 strong" }, "Originalverpackung", -1)),
            (_ctx.hintOvp !== null)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["font7-responsive", { hintAlert: _ctx.hintOvp !== null }])
                }, _toDisplayString(_ctx.hintOvp), 3))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                class: _normalizeClass(["buttonBase buttonBlueInverted w-100 font6-responsive", { clickedButton: _ctx.user_evaluation.ovp === true }]),
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.packagingCheck(true)))
            }, " JA ", 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
                class: _normalizeClass(["buttonBase buttonBlueInverted w-100 font6-responsive", {
                        clickedButton: _ctx.user_evaluation.ovp === false,
                        disabled: _ctx.user_evaluation.condition === 1000 || _ctx.user_evaluation.condition === 1500,
                    }]),
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.packagingCheck(false)))
            }, " NEIN ", 2)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-12 mb-sm-3 mb-1 mt-sm-1 mt-0" }, [
            _createElementVNode("hr", { style: { "color": "#dee2e6" } })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-1 strong" }, "Originalzubehör komplett?", -1)),
            (_ctx.hintAccessory !== null)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["font7-responsive", { hintAlert: _ctx.hintAccessory !== null }])
                }, _toDisplayString(_ctx.hintAccessory), 3))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
                class: _normalizeClass(["buttonBase buttonBlueInverted w-100 font6-responsive", { clickedButton: _ctx.user_evaluation.full_scope_of_delivery === true }]),
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.accessoryCheck(true)))
            }, " JA ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
                class: _normalizeClass(["buttonBase buttonBlueInverted w-100 font6-responsive", {
                        clickedButton: _ctx.user_evaluation.full_scope_of_delivery === false,
                        disabled: _ctx.user_evaluation.condition === 1000,
                    }]),
                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.accessoryCheck(false)))
            }, " NEIN ", 2)
        ])
    ], 2));
}
